import { type Action, createStore } from 'react-sweet-state';

import { PROJECT_TYPE, type ProjectType } from 'src/data/project';
import { homePageBlankProjectType, homePageImproveProjectType } from 'src/lib/localData';
import type { CommonContainerProps } from 'src/lib/sweetState';

export type State = {
  blankProjectType: ProjectType;
  improveProjectType: ProjectType;
};

export type Actions = typeof ACTIONS;
export type ContainerProps = CommonContainerProps<State>;

const DEFAULT_PROJECT_TYPE = PROJECT_TYPE.document;

const INITIAL_STATE: State = {
  blankProjectType: DEFAULT_PROJECT_TYPE,
  improveProjectType: DEFAULT_PROJECT_TYPE,
};

export const PRIVATE_ACTIONS = {
  init:
    (): Action<State> =>
    ({ setState }) => {
      setState({
        blankProjectType: homePageBlankProjectType.read(DEFAULT_PROJECT_TYPE) as ProjectType,
        improveProjectType: homePageImproveProjectType.read(DEFAULT_PROJECT_TYPE) as ProjectType,
      });
    },
};

export const ACTIONS = {
  getBlankProjectType:
    (): Action<State, void, State['blankProjectType']> =>
    ({ getState }) => {
      return getState().blankProjectType;
    },

  updateBlankProjectType:
    (newValue: ProjectType): Action<State> =>
    ({ setState }) => {
      setState({ blankProjectType: newValue });
      homePageBlankProjectType.write(newValue);
    },

  getImproveProjectType:
    (): Action<State, void, State['improveProjectType']> =>
    ({ getState }) => {
      return getState().improveProjectType;
    },

  updateImproveProjectType:
    (newValue: ProjectType): Action<State> =>
    ({ setState }) => {
      setState({ improveProjectType: newValue });
      homePageImproveProjectType.write(newValue);
    },
};

export const MainStore = createStore<State, Actions, ContainerProps>({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: 'new-project-widget',
});
